import { createDeleteEndpoint } from '@sonar-software/sonar-http';

export type DeleteInitiativesRequest = {
	initiativeIds: Array<number>;
};

export const deleteInitiatives = createDeleteEndpoint<DeleteInitiativesRequest>('/api/v3/initiatives/');
